import { domain } from 'modules/data';
import { useMemo } from 'react';
import { findDocumentFieldState } from 'shared/helpers';

export const useNetSuiteItemReceiptItemLinesFieldSettings = (documentFields: domain.DocumentField[] | undefined) =>
    useMemo(
        () => ({
            received: findDocumentFieldState(documentFields, 'ItemsReceived'),
            item: findDocumentFieldState(documentFields, 'ItemsItem'),
            description: findDocumentFieldState(documentFields, 'ItemsDescription'),
            location: findDocumentFieldState(documentFields, 'ItemsLocation'),
            quantity: findDocumentFieldState(documentFields, 'ItemsQuantity'),
            quantityOnHand: findDocumentFieldState(documentFields, 'ItemsQuantityOnHand'),
            quantityRemaining: findDocumentFieldState(documentFields, 'ItemsQuantityRemaining'),
            unitPrice: findDocumentFieldState(documentFields, 'ItemsUnitPrice'),
            amount: findDocumentFieldState(documentFields, 'ItemsAmount'),
        }),
        [documentFields]
    );
